export const ACTIVATED_CONFIRMATION_MODAL = 'ACTIVATED_CONFIRMATION_MODAL'
export const CANCELED_CONFIRMATION_MODAL = 'CANCELED_CONFIRMATION_MODAL'
export const CONFIRMED_CONFIRMATION_MODAL = 'CONFIRMED_CONFIRMATION_MODAL'